/**
 * Collect cache hit/miss ratio metrics for static assets
 * @returns Record containing script cache metrics, or null if Performance API is not supported or no scripts found
 */ export function collectScriptCacheMetrics() {
    if (!performance?.getEntriesByType) {
        return null;
    }
    const scriptEntries = performance.getEntriesByType("resource").filter((entry)=>entry.initiatorType === "script");
    if (scriptEntries.length === 0) {
        return null;
    }
    // Calculate cache metrics
    let cacheHits = 0;
    let totalTransferSize = 0;
    let totalEncodedSize = 0;
    for (const entry of scriptEntries){
        totalEncodedSize += entry.encodedBodySize || 0;
        totalTransferSize += entry.transferSize || 0;
        // Cache hit: transferSize is 0 (resource served from cache)
        if (!entry.transferSize) {
            cacheHits++;
        }
    }
    const totalScripts = scriptEntries.length;
    // Return aggregated cache metrics
    // Cache hit percentage can be calculated as (cacheHits / totalScripts) * 100
    // Cache miss percentage can be calculated as ((totalScripts - cacheHits) / totalScripts) * 100
    // Bandwidth saved can be calculated as (totalEncodedSize - totalTransferSize)
    return {
        totalScripts: totalScripts.toString(),
        cacheHits: cacheHits.toString(),
        totalTransferSize: totalTransferSize.toString(),
        totalEncodedSize: totalEncodedSize.toString()
    };
}
